export enum ButtonColors {
    ADDING = 'ADDING',
    DESCTRUCTIVE ='DESCTRUCTIVE',
    DEFAULT = 'DEFAULT'
}

export enum ButtonSize {
    SMALL = 'SMALL',
    LARGE = 'LARGE',
    FULL_LARGE ='FULL_LARGE'
}

export enum ButtonVariant {
    CONTAINED = 'CONTAINED',
    OUTLINED = 'OUTLINED'
}
